import React from "react";
import { FormattedMessage } from "react-intl";
import { useWindowDimensions } from '../../hooks/useWindowDimensions';
import './Button.less';

const BILButtonPSD2 = (props) => {

    const { type, enabled, onClick, id, right, left } = props;
    const { windowWidth } = useWindowDimensions();

    return (
            <div
                id={id}
                className={`bil-button-psd2`}
                style={{
                    display: 'inline-block',
                    backgroundColor: type === "cancel" ? 'transparent' : '#05c3de',
                    color: type === 'cancel' ? '#05c3de' : 'white',
                    width: windowWidth > 405 ? '185px' : '110px',
                    border: '1px solid #05c3de',
                    pointerEvents: !enabled ? 'none' : 'auto',
                    opacity: !enabled ? '0.25' : '1',
                    marginLeft: left ? '6px' : 'unset',
                    marginRight: right ? '6px' : 'unset'
                }}
                onClick={onClick}
            >
                <div className="BIL_button_flex_IE_parent">
                    <div className="BIL_button_flex_IE_child" style={{minHeight: '50px'}}>
                        <div className="BIL_button_flex_elem" >
                            <FormattedMessage id={type === "cancel" ? 'account-selection.button-cancel' : 'account-selection.button-continue'} />
                        </div>
                    </div>
                </div>
            </div>
    )
}
export default BILButtonPSD2;
